<template>
  <div class="new-product body">
    <el-container>
      <!-- <ProductsAside /> -->
      <el-main>
        <div class="bg-White p-3 mt-2">
          <el-row :gutter="10">
            <el-col :xl="10" :lg="10" :md="24" :sm="24">
              <div class="searchForm" v-if="accessLinks('update_product_categories') && editMode">
                <label for="">تعديل تصنيف </label>
                <el-input
                  class="mt-2 input1"
                  @focus="$event.target.select()"
                  v-model="editForm.name"
                  @keyup.enter.native="updateCategory"
                ></el-input>
              </div>
              <div class="searchForm" v-if="accessLinks('add_product_categories') && !editMode">
                <label for="">وصف تصنيف </label>
                <el-input
                  class="mt-2 input1"
                  @focus="$event.target.select()"
                  v-model="form.name"
                  @keyup.enter.native="addNewCategory"
                ></el-input>
              </div>
            </el-col>
            <el-col :xl="4" :lg="4" :md="12" :sm="12">
              <br />
              <div v-if="accessLinks('update_product_categories') && editMode" class="mt-2">
                <el-button type="warning" @click="updateCategory()">
                  تعديل</el-button
                >
                <el-button type="danger" class="mr-3" @click="cancelEdit()">
                  الغاء</el-button
                >
              </div>
              <el-button
                v-if="accessLinks('add_product_categories') && !editMode"
                class="mt-2"
                type="warning"
                @click="addNewCategory()"
              >
                تسجيل</el-button
              >
            </el-col>
          </el-row>
        </div>
        <el-card class="box-card mt-2">
          <div slot="header" class="clearfix">
            <span>تصنيفات المنتجات</span>
          </div>
          <el-row :gutter="12">
            <el-col
              :lg="4"
              v-for="category in categories"
              :key="category.id"
              style="margin-bottom: 10px"
            >
              <el-card
                :body-style="{ padding: '6px 0px', textAlign: 'center' }"
                style="padding: 10px;"
              >
                <div>{{ category.name }}</div>
                <div style="margin: 10px 0">
                  <el-button
                    v-if="accessLinks('update_product_categories')"
                    type="primary"
                    icon="el-icon-edit"
                    size="mini"
                    style="margin-left:10px"
                    title="تعديل"
                    plain
                    @click="editCategory(category)"
                  ></el-button>
                  <el-popconfirm
                    v-if="accessLinks('delete_product_categories')"
                    confirm-button-text="موافق"
                    cancel-button-text="إلغاء"
                    icon="el-icon-info"
                    icon-color="red"
                    :title="'هل تريد حذف ' + ' ' + category.name + ' ؟'"
                    @confirm="deletecategory(category.id)"
                  >
                    <el-button
                      slot="reference"
                      type="danger"
                      title="مسح"
                      plain
                      icon="el-icon-delete"
                      size="mini"
                      class="mr-3"
                    ></el-button>
                  </el-popconfirm>
                </div>
              </el-card>
            </el-col>
          </el-row>
        </el-card>
      </el-main>
    </el-container>
  </div>
</template>
<script>
// import ProductsAside from "@/components/ProductsAside.vue";
import axiosApi from "@/plugins/axios.js";

export default {
  name: "NewCategory",
  // components: { ProductsAside },
  data() {
    return {
      index: 1,
      false: false,
      categories: [],
      form: {
        name: "",
      },
      editForm: {},
      editMode: false,
    };
  },
  created() {
    this.getCategories();
  },
  mounted() {},
  methods: {
    getCategories() {
      axiosApi
        .get("product-categories")
        .then((res) => {
          this.categories = res.data;
        })
        .catch((error) => console.log(error))
        .finally(() => {});
    },
    editCategory(category) {
      this.editMode = true;
      this.editForm = { ...category };
    },
    cancelEdit() {
      this.editMode = this.false;
    },
    deletecategory(id) {
      axiosApi
        .delete(`product-categories/${id}`)
        .then(() => {
          this.getCategories();
          this.$notify({
            title: "تمت العملية بنجاح",
            message: "تم حفظ بيانات الوصف بنجاح",
            type: "success",
            duration: 1500,
          });
        })
        .catch(() => {
          this.$notify({
            title: "حدث خطأ",
            message: "عفوا لم تتم العملية ",
            type: "error",
            duration: 1500,
          });
        });
    },
    addNewCategory() {
      axiosApi
        .post("product-categories", this.form)
        .then((res) => {
          this.$notify({
            title: "تمت العملية بنجاح",
            message: "تم حفظ بيانات الوصف بنجاح",
            type: "success",
            duration: 1500,
          });
          this.form.name = "";
          this.categories = res.data;
        })
        .catch(() => {
          this.$notify({
            title: "حدث خطأ",
            message: "عفوا لم تتم العملية ",
            type: "error",
            duration: 1500,
          });
        });
    },
    updateCategory() {
      this.editMode = this.false;
      axiosApi
        .put(`product-categories/${this.editForm.id}`, this.editForm)
        .then(() => {
          this.getCategories();
          this.$notify({
            title: "تمت العملية بنجاح",
            message: "تم حفظ بيانات الوصف بنجاح",
            type: "success",
            duration: 1500,
          });
        })
        .catch(() => {
          this.$notify({
            title: "حدث خطأ",
            message: "عفوا لم تتم العملية ",
            type: "error",
            duration: 1500,
          });
        });
    },
    accessLinks(link) {
      let permissionNames = JSON.parse(localStorage.getItem("permissionNames"));
      return permissionNames.includes(link);
    },
  },
};
</script>
